// extracted by mini-css-extract-plugin
export var container = "_97-0";
export var icon = "_97-1";
export var text = "_97-2";